import { render, staticRenderFns } from "./TextListSingleValue.vue?vue&type=template&id=2206bd01"
import script from "./TextListSingleValue.vue?vue&type=script&lang=ts"
export * from "./TextListSingleValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports